<template>
  <el-dialog title="查看合同" :visible.sync="dialogVisible" width="50%">
    <div class="contract-content">
      <el-form
        :model="contractForm"
        ref="contractFormRef"
        label-width="80px"
        :disabled="true"
      >
        <el-form-item label="合同名称" prop="contractName">
          <el-input
            v-model="contractForm.contractName"
            placeholder="请输入合同名称"
          />
        </el-form-item>
        <el-form-item label="合同编码" prop="contractCode">
          <el-input
            v-model="contractForm.contractCode"
            placeholder="请输入合同编码"
          />
        </el-form-item>
        <el-form-item label="签署方一" prop="draftShopName">
          <el-input
            v-model="contractForm.draftShopName"
            placeholder="请选择签署方"
          />
        </el-form-item>
        <el-form-item label="签署方二" prop="coopShopId">
           <el-input
            v-model="contractForm.coopShopName"
            placeholder="请选择签署方"
          />
        </el-form-item>
      </el-form>
      <div class="upload-container">
        <div class="">
          <ossFileUpload
            ref="refPicFileUpload"
            v-model="picFileList"
            :limit="maxFileCount"
            :accept="picFileExt"
            :maxFileLength="10"
            :ossUpload="true"
            :ossPathDir="'shop/pic/'"
            style="margin-bottom: 10px"
            :disabled="isDisabled"
            :onPreview="handlePreview"
          >
          </ossFileUpload>
          <div class="small-tip warning" v-if="!isDisabled">
            <span
              >最多支持{{ maxFileCount }}张，单张不超过10M； 支持{{
                picFileExt
              }}</span
            >
          </div>
        </div>
      </div>
      <!-- 审核区域 -->
      <div
        class="audit-section"
        v-show="form.auditResult && form.auditResult != 0"
      >
        <el-form :model="form" ref="formRef">
          <el-form-item label="审核结果" prop="auditResult">
            <div>{{ checkStatusMap[form.auditResult] }}</div>
          </el-form-item>
          <!-- 驳回理由 -->
          <el-form-item
            v-if="form.auditResult === 2"
            label="驳回理由"
            prop="rejectReason"
          >
            <div>{{ form.rejectReason }}</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <FileViewer ref="fileViewerRef" />
  </el-dialog>
</template>

<script>
import FileViewer from "@/components/FileViewer";
import ossFileUpload from "@/components/ossFileUpload";
import { getOssSrcFileName } from "@/utils/oss";
export default {
  name: "ContractDialog",
  components: {
    FileViewer,
    ossFileUpload,
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      picFileList: [],
      picFileExt: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
      maxFileCount: 9,
      isDisabled: true,
      // 审核相关
      form: {
        auditResult: null, // 1:通过, 2:驳回
        rejectReason: "",
      },
      checkStatusMap: {
        0: "待审核",
        1: "通过",
        2: "驳回",
      },
      contractForm: {
        contractName: '',
        contractCode: '',
        draftShopName: '',
        coopShopName: '',
      }
    };
  },
  methods: {
    open(contract) {
      this.dialogVisible = true;
      const { id, fileUrl, checkStatus, checkRemark , contractName, contractCode, draftShopName, coopShopName } = contract;
      this.contractForm.contractName = contractName;
      this.contractForm.contractCode = contractCode;
      this.contractForm.draftShopName = draftShopName;
      this.contractForm.coopShopName = coopShopName;
      this.form.auditResult = checkStatus;
      if (checkStatus == 2) {
        this.form.rejectReason = checkRemark;
      }
      this.checkDisable = checkStatus !== 0;
      if (fileUrl) {
        const urls = fileUrl.split(",");
        this.picFileList = urls.map((item) => {
          return this.parseToUploadUrl(item);
        });
      }else{
        this.picFileList = [];
      }
      this.contractId = id;
      this.$nextTick(() => {
        this.$refs.refPicFileUpload.init(); //初始化oss上传
      });
    },
    handlePreview(file) {
      const { url } = file;
      // window.open(url);
      this.$refs.fileViewerRef.publicOpen(url);
    },
    parseToUploadUrl(newUrl) {
      if (newUrl) {
        const name = getOssSrcFileName(newUrl); //newUrl.split("/");
        return {
          name: name,
          url: newUrl,
          response: { data: { fileName: name, url: newUrl } },
        };
      }
      return null;
    },
  },
};
</script>

<style scoped>
.contract-content {
  padding: 20px 0;
}
.contract-preview {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
</style>